const translations = {
  "en": {
    "Account creation error": "Account creation error",
    "Already have a Connect account": "Already have a Connect account?",
    "Be 8 to 256 characters long": "Be 8 to 256 characters long",
    "Be sure to keep it safe": "Be sure to keep it safe.",
    "Be sure to keep them safe": "Be sure to keep them safe.",
    "By creating an account, you agree to Videojet's": "By creating an account, you agree to Videojet's",
    "C_AvlExport_SuccessBreadcrumb": "Success",
    "Change": "Change",
    "Company": "Company:",
    "ConfirmNewPassword": "Confirm new password",
    "Contain a lowercase letter": "Contain a lowercase letter",
    "Contain a number": "Contain a number",
    "Contain an uppercase letter": "Contain an uppercase letter",
    "Continue": "Continue",
    "Create an account": "Create an account",
    "Create my account": "Create my account",
    "Deutsch": "Deutsch",
    "Dutch": "Dutch",
    "Email address": "Email address:",
    "English": "English",
    "Error, an SSO account already exists": "Error, an SSO account already exists.",
    "Error, email or password is incorrect": "Error, email or password is incorrect.",
    "Error, please complete this field": "Error, please complete this field.",
    "Error, please correct this field": "Error, please correct this field.",
    "First Name": "First Name:",
    "Forgotten password": "Forgotten password",
    "French": "French",
    "German": "German",
    "Go to log in": "Go to log in",
    "Hello": "Hello,",
    "HomePageTitle": "Welcome to VideojetConnect™",
    "I would like to receive marketing emails": "I would like to receive marketing emails",
    "Italian": "Italian",
    "Last Name": "Last Name:",
    "Log in": "Log in",
    "Log in using your new account credentials": "Log in using your new account credentials.",
    "New email sent with a temporary password": "New email sent with a temporary password.",
    "Next": "Next",
    "No option selected": "No option selected",
    "Not a Connect customer yet": "Not a Connect customer yet?",
    "Password": "Password:",
    "Please enter the 6-digit verification code": "Please enter the 6-digit verification code that we've sent to the above email address. This code will expire in 24 hours. If you don't see it, check your junk folder.",
    "Polish": "Polish",
    "Portuguese": "Portuguese",
    "Preferred Language": "Preferred Language:",
    "PrivacyPolicy": "privacy policy",
    "Register your email address": "Register your email address",
    "Resend the code": "Resend the code",
    "Reset your password": "Reset your password",
    "Set your password": "Set your password",
    "Smarter, safer software": "Smarter, safer software to power your coding production.",
    "Spanish": "Spanish",
    "System Default": "System Default",
    "Step 1 of 2": "Step 1 of 2",
    "Step 1 of 4": "Step 1 of 4",
    "Step 2 of 2": "Step 2 of 2",
    "Step 2 of 4": "Step 2 of 4",
    "Step 3 of 4": "Step 3 of 4",
    "Step 4 of 4": "Step 4 of 4",
    "Tell us who you are": "Tell us who you are",
    "Turkish": "Turkish",
    "Verification code": "Verification code:",
    "Verification code sent to the email": "Verification code sent to the email",
    "Verify my account": "Verify my account",
    "Verify your email": "Verify your email",
    "Your organization has already set up your account using SSO": "Your organization has already set up your account using SSO. Contact your administrator for help.",
    "Your password has been reset": "Your password has been reset",
    "Your password must": "Your password must:",
    "Your user account has been created": "Your user account has been created",
    "You'll need to log back in using the new password": "You'll need to log back in using the new password",
    "An account using the supplied email address already exists": "An account using the supplied email address already exists. Would you like to log in instead?"
  },
  "tr": {
    "A cloud-based ecosystem": "Veri toplama, üretim verimliliğini artırma ve süreçleri optimize etme için akıllı araçlar sunan bulut tabanlı bir ekosistem",
    "Account creation error": "Hesap oluşturma hatası",
    "Already have a Connect account": "Zaten bir Connect hesabınız var mı?",
    "Be 8 to 256 characters long": "8 ila 256 karakter uzunluğunda olmalı",
    "Be sure to keep it safe": "Güvende tuttuğunuzdan emin olun.",
    "Be sure to keep them safe": "Onları güvende tuttuğunuzdan emin olun.",
    "By creating an account, you agree to Videojet's": "Hesap oluşturarak Videojet'in",
    "C_AvlExport_SuccessBreadcrumb": "Başarılı",
    "Change": "Değiştir",
    "Company": "Şirket:",
    "ConfirmNewPassword": "Yeni şifreyi onayla",
    "Contain a lowercase letter": "Küçük harf içermeli",
    "Contain a number": "Bir rakam içermeli",
    "Contain an uppercase letter": "Büyük harf içermeli",
    "Continue": "Devam et",
    "Create an account": "Hesap oluştur",
    "Create my account": "Hesabımı oluştur",
    "Deutsch": "Almanca",
    "Dutch": "Felemenkçe",
    "Email address": "E-posta adresi:",
    "English": "İngilizce",
    "Error, an SSO account already exists": "Hata, bir SSO hesabı zaten mevcut.",
    "Error, email or password is incorrect": "Hata, e-posta veya şifre yanlış.",
    "Error, please complete this field": "Hata, lütfen bu alanı doldurun.",
    "Error, please correct this field": "Hata, lütfen bu alanı düzeltin.",
    "First Name": "Ad:",
    "Forgotten password": "Şifrenizi mi unuttunuz",
    "French": "Fransızca",
    "German": "Almanca",
    "Go to log in": "Giriş ekranına git",
    "Hello": "Merhaba,",
    "HomePageTitle": "VideojetConnect™‘e Hoş Geldiniz",
    "I would like to receive marketing emails": "Pazarlama e-postaları almak istiyorum",
    "Italian": "İtalyanca",
    "Last Name": "Soyad:",
    "Log in": "Giriş yap",
    "Log in using your new account credentials": "Yeni hesap bilgilerinizle giriş yapın.",
    "New email sent with a temporary password": "Geçici şifre içeren yeni bir e-posta gönderildi.",
    "Next": "İleri",
    "No option selected": "Hiçbir seçenek seçilmedi",
    "Not a Connect customer yet": "Henüz bir Connect müşterisi değil misiniz?",
    "Password": "Şifre:",
    "Please enter the 6-digit verification code": "Lütfen yukarıdaki e-posta adresine gönderdiğimiz 6 haneli doğrulama kodunu girin. Bu kod 24 saat içinde geçerliliğini yitirecektir. Gelen kutunuzda göremiyorsanız, spam klasörünü kontrol edin.",
    "Polish": "Lehçe",
    "Portuguese": "Portekizce",
    "Preferred Language": "Tercih edilen dil:",
    "PrivacyPolicy": "gizlilik politikası",
    "Register your email address": "E-posta adresinizi kaydedin",
    "Resend the code": "Kodu tekrar gönder",
    "Reset your password": "Şifrenizi sıfırlayın",
    "Set your password": "Şifrenizi belirleyin",
    "Smarter, safer software": "Kodlama üretiminizi güçlendiren daha akıllı ve daha güvenli yazılım.",
    "Spanish": "İspanyolca",
    "System Default": "Sistem varsayılanı",
    "Step 1 of 2": "Adım 1 / 2",
    "Step 1 of 4": "Adım 1 / 4",
    "Step 2 of 2": "Adım 2 / 2",
    "Step 2 of 4": "Adım 2 / 4",
    "Step 3 of 4": "Adım 3 / 4",
    "Step 4 of 4": "Adım 4 / 4",
    "Tell us who you are": "Kendinizi tanıtın",
    "Turkish": "Türkçe",
    "Verification code": "Doğrulama kodu:",
    "Verification code sent to the email": "Doğrulama kodu e-posta adresinize gönderildi",
    "Verify my account": "Hesabımı doğrula",
    "Verify your email": "E-posta adresinizi doğrulayın",
    "Your organization has already set up your account using SSO": "Kuruluşunuz hesabınızı SSO kullanarak zaten oluşturdu. Yardım için yöneticinizle iletişime geçin.",
    "Your password has been reset": "Şifreniz sıfırlandı",
    "Your password must": "Şifreniz şu kurallara uymalı:",
    "Your user account has been created": "Kullanıcı hesabınız oluşturuldu",
    "You'll need to log back in using the new password": "Yeni şifrenizle tekrar giriş yapmanız gerekecek",
    "An account using the supplied email address already exists": "Sağlanan e-posta adresiyle zaten bir hesap var. Bunun yerine giriş yapmak ister misiniz?"
  }
};

export default translations;